    document.addEventListener('DOMContentLoaded', () => {
      localStorage.setItem('lastProduct', null);
      localStorage.setItem('lastPrompt', null);
      localStorage.setItem('askedForClarify', null);

      const chatForm = document.getElementById('chat-form');
      const chatCont = document.getElementById('chat-cont');
      const chatOutput = document.getElementById('chat-output');
      let lastProduct = localStorage.getItem('lastProduct') || null;
      let lastPrompt = localStorage.getItem('lastPrompt') || null;
      const submitButton = chatForm ? chatForm.querySelector('button[type="submit"]') : null;
      let askedForClarify = localStorage.getItem('askedForClarify') || false;
      const inputField = document.getElementById('input-field');
      let messageIdCounter = 0; // Counter for unique message IDs 
      let autoScrollDisabledForCurrentMessage = false;

      // Suppose `chatOutput` is your #chat-output element
      chatOutput.addEventListener('touchstart', disableAutoScroll);
      chatOutput.addEventListener('wheel', disableAutoScroll);
      chatOutput.addEventListener('scroll', handleUserScroll);
      function handleUserScroll() {
        // If user manually scrolls up from the bottom, disable auto-scroll
        const nearBottom = chatOutput.scrollHeight - chatOutput.scrollTop - chatOutput.clientHeight < 1;
        if (!nearBottom) {
          disableAutoScroll();
        }
      }
      
      // Make sure you have a button in your HTML with id="start-new-chat"
      const startNewChatButton = document.getElementById('start-new-chat');
      if (startNewChatButton) {
        startNewChatButton.addEventListener('click', () => {
          startNewChatButton.style.visibility = "hidden";
          // 1. Clear relevant localStorage items
          localStorage.setItem('lastProduct', null);
          localStorage.setItem('lastPrompt', null);
          localStorage.setItem('askedForClarify', null);
          lastProduct =  null;
          lastPrompt = null;
          // 2. Remove only the AI/grok messages from chatOutput
          const grokMessages = chatOutput.querySelectorAll('.grok-message');
          grokMessages.forEach(msg => msg.remove());
          const userMessages = chatOutput.querySelectorAll('.user-message');
          userMessages.forEach(msg => msg.remove());
        });
      }
      function disableAutoScroll() {
        // The user has touched or tried to scroll, so stop auto-scrolling
        autoScrollDisabledForCurrentMessage = true;
      }

      // Create and append a circular cursor element
      const cursor = document.createElement('div');
      cursor.id = 'stream-cursor';
      cursor.style.position = 'absolute';
      cursor.style.width = '10px';
      cursor.style.height = '10px';
      cursor.style.border = '2px solid #0056b3';
      cursor.style.borderRadius = '50%';
      cursor.style.pointerEvents = 'none';
      cursor.style.zIndex = '1000';
      cursor.style.display = 'none';
      document.body.appendChild(cursor);

      // Create a string with the robot HTML snippet
      const robotHtml = `
        <div class="cute-robot-v1" style="margin-top: 5px;">
          <div class="circle-bg">
            <div class="robot-ear left"></div>
            <div class="robot-head">
              <div class="robot-face">
                <div class="eyes left"></div>
                <div class="eyes right"></div>
                <div class="mouth"></div>
              </div>
            </div>
            <div class="robot-ear right"></div>
            <div class="robot-body"></div>
          </div>
        </div>
      `;
      const robotHtml2 = `
        <div class="cute-robot-v1 hideMeMob" style="margin-top: 5px;">
          <div class="circle-bg">
            <div class="robot-ear left"></div>
            <div class="robot-head">
              <div class="robot-face">
                <div class="eyes left"></div>
                <div class="eyes right"></div>
                <div class="mouth"></div>
              </div>
            </div>
            <div class="robot-ear right"></div>
            <div class="robot-body"></div>
          </div>
        </div>
      `;

      // Helper function to find the last visible text node
      function getLastVisibleTextNode(node) {
        if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== '') {
          return node;
        }
        for (let i = node.childNodes.length - 1; i >= 0; i--) {
          const child = node.childNodes[i];
          const textNode = getLastVisibleTextNode(child);
          if (textNode) {
            return textNode;
          }
        }
        return null;
      }

      function sendUserSelection(product, variant) {
        fetch('https://support.aimshop.com/aichat/GPTV2.php', {
          method: 'POST',
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ product, variant })
        })
        .then(response => response.text())
        .then(data => {
          console.log("Server response:", data);
        })
        .catch(error => {
          console.error("Error sending clarification:", error);
        });
        // Remove prompt buttons after selection
        document.querySelectorAll(".variant-button").forEach(btn => btn.remove());
      }

      function handleVariantSelection(message, product, variants) {
        const chatBox = document.getElementById("chat-output");
        // Create message container
        const messageContainer = document.createElement("div");
        messageContainer.className = "message grok-message";
        messageContainer.innerHTML = `<p>${message}</p>`;
        // Create selection buttons
        variants.forEach(variant => {
          const button = document.createElement("button");
          button.className = "variant-button";
          button.innerText = variant;
          button.onclick = function() {
            sendUserSelection(product, variant);
          };
          messageContainer.appendChild(button);
        });
        chatBox.appendChild(messageContainer);
        chatBox.scrollTop = chatBox.scrollHeight;
      }

      // Helper function to check viewport width
      function checkViewportWidth() {
        const breakpoint = 600;
        return window.innerWidth < breakpoint;
      }

      // Update cursor position (centered on the last line of the streamed text)
      function updateCursorPosition(targetElement) {
        if (!targetElement) return;
        const lastTextNode = getLastVisibleTextNode(targetElement);
        if (!lastTextNode) return;
        const range = document.createRange();
        const selection = window.getSelection();
        try {
          range.selectNodeContents(lastTextNode);
          range.collapse(false);
          const rect = range.getBoundingClientRect();
          const cursorDiameter = 10;
          const chatOutputRect = chatOutput.getBoundingClientRect();
          if (rect.top > chatOutputRect.bottom || rect.bottom > chatOutputRect.bottom) {
            cursor.style.display = 'none';
          } else {
            cursor.style.top = `${rect.top + window.scrollY + rect.height / 2 - cursorDiameter / 2}px`;
            cursor.style.left = `${rect.right + window.scrollX + 10}px`;
            cursor.style.display = 'block';
          }
        } catch (error) {
          console.error('Error updating cursor position:', error);
        } finally {
          selection.removeAllRanges();
        }
      }

      // Hide the cursor
      function hideCursor() {
        cursor.style.display = 'none';
      }

      if (chatForm && chatOutput) {
        chatForm.addEventListener('submit', async (e) => {
          startNewChatButton.style.visibility = "visible";
          e.preventDefault();
          const query = chatForm.querySelector('input[name="query"]').value;
          // 1. Display user's message
          const userMessage = document.createElement('div');
          userMessage.className = 'message user-message';
          userMessage.innerHTML = query;
          chatOutput.appendChild(userMessage);
          chatOutput.scrollTop = chatOutput.scrollHeight;
          // Clear the input after sending
          chatForm.querySelector('input[name="query"]').value = '';
          submitButton.disabled = true;
          inputField.disabled = true;
          chatForm.style.opacity = 0.2;

          // 2. Show the thinking indicator (spinner)
          const thinkingMessage = document.createElement('div');
          thinkingMessage.id = 'thinking-indicator';
          thinkingMessage.className = 'message';
          thinkingMessage.innerHTML = `<div style="display:flex; align-items:center">
                                          ${robotHtml} <span class="spinner"></span>
                                        </div>`;
          chatOutput.appendChild(thinkingMessage);
          chatOutput.scrollTop = chatOutput.scrollHeight;
          
          try {
            // 3. Fetch from the SSE endpoint
            const response = await fetch('https://support.aimshop.com/aichat/GPTV2.php', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ query, lastProduct, lastPrompt, askedForClarify })
            });
            if (!response.body) {
              throw new Error('Server did not return a body for streaming.');
            }
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let accumulatedResponse = '';
            let firstChunkReceived = false;
            let grokStreamMessage = null;

            // 4. Read the SSE stream chunk by chunk
            while (true) {
              const { done, value } = await reader.read();
              if (done) break;
              const chunk = decoder.decode(value, { stream: true });
              const lines = chunk.split('\n');
              for (const line of lines) {
                const trimmed = line.trim();
                if (trimmed.startsWith('data: ')) {
                  const jsonStr = trimmed.replace(/^data:\s*/, '');
                  if (jsonStr === '[DONE]') {
                    console.log('SSE stream done');
                    submitButton.disabled = false;
                    inputField.disabled = false;
                    inputField.focus();
                    chatForm.style.opacity = 1;
                    hideCursor();
                    // Remove streaming class when done
                    const circleBg = document.querySelector(`#grok-message-${messageIdCounter} .circle-bg`);
                    if (circleBg) {
                      circleBg.classList.remove('streaming');
                    }
                    // Append helper icons after stream ends
                    const helperIcons = document.createElement('div');
                    helperIcons.id = `helper-icons-${messageIdCounter}`;
                    helperIcons.className = `helper-icons`;
                    helperIcons.innerHTML = `
                      <div class="icon-container clone" data-target="chatStream-${messageIdCounter}" title="Copy content">
                        <i class="fa-regular fa-clone" data-target="chatStream-${messageIdCounter}"></i>
                        <span class="tooltip">Copy Response</span>
                      </div>
                      <div class="icon-container flag" data-target="chatStream-${messageIdCounter}" title="Flag content">
                        <i class="fa-regular fa-flag" data-target="chatStream-${messageIdCounter}"></i>
                        <span class="tooltip">Flag Content</span>
                      </div>`;
                    const helpText = document.createElement('div');
                    helpText.style = "font-size:13px; color:#b3b0b0";
                    helpText.innerHTML = '<div style="font-size: 13px; color: #b3b0b0; margin-top: 10px;">Let us know if this response was not helpful</div>';
                    const parentNode = document.getElementById(`chatStream-${messageIdCounter}`);
                    parentNode.appendChild(helperIcons);
                    parentNode.appendChild(helpText);
                    bindButtonActions(`chatStream-${messageIdCounter}`, userMessage);
                    messageIdCounter++;
                    if (!autoScrollDisabledForCurrentMessage) {
                      chatOutput.scrollTop = chatOutput.scrollHeight;
                    }
                    break;
                  }
                  try {
                    const parsed = JSON.parse(jsonStr);
                    if (parsed.function === "promptUser") {
                      handleVariantSelection(parsed.message, parsed.product, parsed.variants);
                    } else if (parsed.content) {
                      // Remove spinner on first chunk
                      if (!firstChunkReceived) {
                        autoScrollDisabledForCurrentMessage = false;
                        thinkingMessage.remove();
                        firstChunkReceived = true;
                        grokStreamMessage = document.createElement('div');
                        grokStreamMessage.className = 'message grok-message';
                        grokStreamMessage.id = `grok-message-${messageIdCounter}`; // Unique ID
                        grokStreamMessage.innerHTML = `
                          ${robotHtml2}
                          <div id="chatStream-${messageIdCounter}">
                            ${parsed.content}
                          </div>`;
                        chatOutput.appendChild(grokStreamMessage);
                        // Add the streaming class as before (for non-thinking updates)
                        const circleBg = grokStreamMessage.querySelector('.cute-robot-v1 .circle-bg');
                        if (circleBg) circleBg.classList.add('streaming');
                      }
                      const chatStream = grokStreamMessage.querySelector(`#chatStream-${messageIdCounter}`);
                      
// If it's a system update indicated by the shimmer markup…
if (parsed.content.startsWith("<i class='shimmer'>")) {
  if (parsed.content.toLowerCase().includes("thinking")) {
    // Remove any reasoning classes before adding thinking classes
    const robotFace = grokStreamMessage.querySelector('.robot-face');
    if (robotFace) {
      robotFace.classList.remove('reason-face');
      robotFace.classList.add('thinking-face');
    }
    const eyes = grokStreamMessage.querySelectorAll('.robot-face .eyes');
    eyes.forEach(eye => {
      eye.classList.remove('reason-eyes');
      eye.classList.add('thinking-eyes');
    });
    const mouth = grokStreamMessage.querySelector('.robot-face .mouth');
    if (mouth) {
      mouth.classList.remove('reason-mouth');
      mouth.classList.add('thinking-mouth');
    }
    if (chatStream) {
      chatStream.innerHTML = `<span style="color: gray; font-style: italic;">${parsed.content}</span>`;
    }
  } else if (parsed.content.toLowerCase().includes("reasoning")) {
    // Remove any thinking classes before adding reasoning classes
    const robotFace = grokStreamMessage.querySelector('.robot-face');
    if (robotFace) {
      robotFace.classList.remove('thinking-face');
      robotFace.classList.add('reason-face');
    }
    const eyes = grokStreamMessage.querySelectorAll('.robot-face .eyes');
    eyes.forEach(eye => {
      eye.classList.remove('thinking-eyes');
      eye.classList.add('reason-eyes');
    });
    const mouth = grokStreamMessage.querySelector('.robot-face .mouth');
    if (mouth) {
      mouth.classList.remove('thinking-mouth');
      mouth.classList.add('reason-mouth');
    }
    if (chatStream) {
      chatStream.innerHTML = `<span style="color: gray; font-style: italic;">${parsed.content}</span>`;
    }
  } else {
    // For any other shimmer update, run the original effect.
    if (chatStream) {
      document.querySelectorAll('.shimmer').forEach(element => element.remove());
      chatStream.innerHTML = `<span style="color: gray; font-style: italic;">${parsed.content}</span>`;
    }
  }
} else {
  // For normal streamed content, remove any thinking or reasoning classes if they exist.
  if (grokStreamMessage) {
    const robotFace = grokStreamMessage.querySelector('.robot-face');
    if (robotFace) {
      robotFace.classList.remove('thinking-face', 'reason-face');
    }
    const eyes = grokStreamMessage.querySelectorAll('.robot-face .eyes');
    eyes.forEach(eye => eye.classList.remove('thinking-eyes', 'reason-eyes'));
    const mouth = grokStreamMessage.querySelector('.robot-face .mouth');
    if (mouth) {
      mouth.classList.remove('thinking-mouth', 'reason-mouth');
    }
  }
  accumulatedResponse += parsed.content;
  if (chatStream) {
    chatStream.innerHTML = accumulatedResponse;
  }
}


                      if (!autoScrollDisabledForCurrentMessage) {
                        chatOutput.scrollTop = chatOutput.scrollHeight;
                      }
                      updateCursorPosition(chatStream);

                      // Save conversation context
                      lastProduct = parsed.lastProduct;
                      localStorage.setItem('lastProduct', lastProduct);
                      lastPrompt = parsed.lastPrompt;
                      localStorage.setItem('lastPrompt', lastPrompt);
                      askedForClarify = parsed.askedForClarify;
                      localStorage.setItem('askedForClarify', askedForClarify);
                    }
                  } catch (err) {
                    console.error('Error parsing SSE line:', err, line);
                  }
                }
              }
            }
            // If no chunks were received, show an error
            if (!firstChunkReceived) {
              thinkingMessage.remove();
              const errorMessage = document.createElement('div');
              errorMessage.className = 'message grok-message';
              errorMessage.innerHTML = `<i class="system-icon fa-solid fa-robot"></i> Sorry, I got no response.`;
              chatOutput.appendChild(errorMessage);
            }
          } catch (error) {
            console.error('Error:', error);
            if (document.getElementById('thinking-indicator')) {
              thinkingMessage.remove();
            }
            const errorMsg = document.createElement('div');
            errorMsg.className = 'message grok-message';
            errorMsg.textContent = 'Error: Unable to fetch streamed response.';
            chatOutput.appendChild(errorMsg);
          }
        });
      } else {
        console.error('Chat form or output not found in the DOM');
      }

      function bindButtonActions(chatStreamId, userMessage) {
        // Copy action for the clone button
        const cloneButton = document.querySelector(`[data-target="${chatStreamId}"].clone`);
        if (cloneButton) {
          cloneButton.addEventListener('click', () => {
            const chatStream = document.getElementById(chatStreamId);
            if (chatStream) {
              const range = document.createRange();
              range.selectNodeContents(chatStream);
              const selection = window.getSelection();
              selection.removeAllRanges();
              selection.addRange(range);
              document.execCommand('copy');
              selection.removeAllRanges();
              showToast('Content copied to clipboard!');
            }
          });
        }
        // Function to show a toast notification
        function showToast(message) {
          const toast = document.createElement('div');
          toast.textContent = message;
          toast.style.position = 'fixed';
          toast.style.top = '10px';
          toast.style.left = '50%';
          toast.style.transform = 'translateX(-50%)';
          toast.style.backgroundColor = '#323232';
          toast.style.color = '#fff';
          toast.style.padding = '10px 20px';
          toast.style.borderRadius = '5px';
          toast.style.boxShadow = '0px 4px 6px rgba(0, 0, 0, 0.1)';
          toast.style.zIndex = '1000';
          toast.style.opacity = '1';
          toast.style.transition = 'opacity 0.5s ease';
          document.body.appendChild(toast);
          setTimeout(() => {
            toast.style.opacity = '0';
            setTimeout(() => {
              toast.remove();
            }, 500);
          }, 2000);
        }
        // Flag action for the flag button
        const flagButton = document.querySelector(`[data-target="${chatStreamId}"].flag`);
        if (flagButton) {
          flagButton.addEventListener('click', () => {
            const chatStream = document.getElementById(chatStreamId);
            if (chatStream) {
              const modal = document.createElement('div');
              modal.className = 'modal';
              modal.innerHTML = `
                <div class="modal-content">
                  <h3>Flag Content</h3>
                  <textarea id="userMessageInput" placeholder="Add a message (optional)..."></textarea>
                  <div class="modal-actions">
                    <button id="closeModalButton">Cancel</button>
                    <button id="sendFlagButton">Submit</button>
                  </div>
                </div>`;
              document.body.appendChild(modal);
              document.getElementById('sendFlagButton').addEventListener('click', () => {
                const userMessageInput = document.getElementById('userMessageInput').value;
                const userMessageContent = userMessage ? userMessage.innerHTML : 'No user message found.';
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = chatStream.innerHTML;
                let chatStreamContent = tempDiv.textContent || tempDiv.innerText || '';
                chatStreamContent = chatStreamContent.replace(/Copy content\s*Flag content\s*$/, '').trim();
                fetch('https://support.aimshop.com/aichat/sendMail.php', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    userMessage: userMessageContent,
                    chatStream: chatStreamContent,
                    userAdditionalMessage: userMessageInput
                  })
                }).then(response => {
                  if (response.ok) {
                    showToast('Content flagged successfully!');
                  } else {
                    showToast('Failed to flag content. Please try again.');
                  }
                }).catch(error => {
                  console.error('Error flagging content:', error);
                });
                modal.remove();
              });
              document.getElementById('closeModalButton').addEventListener('click', () => {
                modal.remove();
              });
            }
          });
        }
      }
    });